import { render, staticRenderFns } from "./labelManagement.vue?vue&type=template&id=36f53794&scoped=true"
import script from "./labelManagement.vue?vue&type=script&lang=js"
export * from "./labelManagement.vue?vue&type=script&lang=js"
import style0 from "./labelManagement.vue?vue&type=style&index=0&id=36f53794&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f53794",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36f53794')) {
      api.createRecord('36f53794', component.options)
    } else {
      api.reload('36f53794', component.options)
    }
    module.hot.accept("./labelManagement.vue?vue&type=template&id=36f53794&scoped=true", function () {
      api.rerender('36f53794', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cont/labelManagement.vue"
export default component.exports